<template>
  <cube-page :title="$route.query.title + '覆盖'">
    <div slot="content" class="content">
      <wmq-layout
        ref="dept"
        :rootLayoutConfig="rootLayoutConfig" />
    </div>
  </cube-page>
</template>

<script>

import deptUiConfig from '@/config/ui-config/product-cover-dept-by-city-ui-config'
import { biData } from '@/api/cube'
import { WmqDashboardCubeDataHelperMixin, CubeDataHandle } from 'wmq-component'
import { set } from 'lodash'
import CubePage from '../../components/cube-page'
export default {
  name: 'ProductCoverByDept',
  components: { CubePage },
  mixins: [WmqDashboardCubeDataHelperMixin],
  data() {
    return {
    }
  },
  mounted() {
    this.$refs['dept'].refreshAll()
    console.log(this.$route.query)
  },
  computed: {
    rootLayoutConfig () {
      const height = document.body.clientHeight - 100
      console.log('height', height)
      set(deptUiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return deptUiConfig
    }
  },
  provide () {
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        reqObj.channelType = that.$route.query.channelType
        reqObj.productBrand = that.$route.query.productBrand
        reqObj.month = that.$route.query.month
        reqObj.dept = that.$route.query.dept
        return biData(data.dataCode, reqObj).then(res => {
          return new Promise((resolve) => {
            resolve(CubeDataHandle.handleCubeData(res.data))
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.content{
  margin-top: 15px;
  }
</style>
